import adminApiClient from '../../api/base/adminApiClient'

export type PolicyKey = 'terms' | 'privacy' | 'marketing'

export interface AdminPolicy {
  key: PolicyKey
  title: string
  content: string
  updated_at: string | null
}

export interface GetPoliciesResponse {
  data: AdminPolicy[]
}

export interface UpdatePolicyRequest {
  title?: string
  content: string
}

export const adminPolicyApi = {
  getPolicies: async (): Promise<GetPoliciesResponse> => {
    const response = await adminApiClient.get<GetPoliciesResponse>(
      '/admin/policies'
    )
    return response.data
  },
  updatePolicy: async (
    key: string,
    data: UpdatePolicyRequest
  ): Promise<AdminPolicy> => {
    const response = await adminApiClient.put<AdminPolicy>(
      `/admin/policies/${key}`,
      data
    )
    return response.data
  },
}
